import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import Loader from '../../../components/base/Loader/Loader';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import './authorized.scss';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';

export default function ProfilePage() {
  const { formatMessage } = useIntl();
  const list = [];
  const columns = [
    {
      dataField: 'lp_text',
      text: 'Услуга',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: 'Номер',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: 'Дата подачи',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: 'Дата планового ответа',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: 'Исполнитель',
      disableSort: true,
    },
    {
      dataField: 'lp_text',
      text: 'Статус',
      disableSort: true,
    },

  ];
  const panelInfo = [];
  const renderInfoPanel = ({
    icon, title, count, className,
  }, key) => (
    <div key={key} className={classNames('info-panel', className)}>
      <div className="info-panel-label">
        <div className="text-block">{title}</div>
        <div className="icon-block"><Icons icon={icon} customIcon /></div>
      </div>
      <div className="info-panel-count">
        <div className="number-block">{count}</div>
        <div className="text-block">{formatMessage({ id: 'panel.info.appeal' }, { count })}</div>
      </div>
    </div>
  );

  const avatarLink = '';
  const defaultAvatar = `${process.env.PUBLIC_URL}/img/default-avatar.svg`;

  return (
    <div className="page profile-page">
      <Loader loading={false} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.profile' })}</div>
      </div>
      <div className="page-content-wrapper frame">
        <div className="info">
          <div className="info-panel-header">Статистика за неделю</div>
          <div className="info-panel-wrapper">
            {panelInfo.map(renderInfoPanel)}
          </div>
          <div className="info-panel-header">Мои обращения</div>
          <div className="appeal-grid mt-3">
            <div className="grid-wrapper">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <Grid data={list} columns={columns} name="profile-list" />
              </div>
            </div>
          </div>
        </div>
        <div className="profile">
          <div className="profile-label">Учетная запись</div>
          <div className="profile-avatar-wrapper">
            <img
              className="profile-avatar"
              src={avatarLink}
              alt="A"
              onError={e => {
                e.target.src = defaultAvatar;
              }}
            />
          </div>
          <div className="profile-fio">
            Петров Иван Константинович
          </div>
          <div className="profile-buttons">
            <Button>Редактировать</Button>
            <Button variant="secondary">Просмотреть</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
